import { useContext } from "react"
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import { AccountContext } from "../contexts/AccountContexts"

export const BreadCrumbsGeneral = ({ elements }) => {
    const navigator = useNavigate()
    const { language } = useContext(AccountContext)


    return (
        <div className="flex items-center gap-2 text-gray-800 dark:text-gray-300 text-sm">
            {
                elements.map((element, index) =>
                    <div key={index} className="flex items-center gap-2">
                        <a className={`${element.link ? "cursor-pointer hover:underline" : "opacity-80"}`} onClick={() => { element.link && navigator(element.link) }} >{element.name}</a>
                        {
                            element.link && language !== "ar" &&
                            <MdKeyboardArrowRight size={16} />
                        }
                        {
                            element.link && language === "ar" &&
                            <MdKeyboardArrowLeft size={16} />
                        }
                    </div >
                )
            }
        </div>
    )
}